import { createReducer, on } from '@ngrx/store';
import * as fromActions from './actions';
import { IdentityProviderMessagingTokenParticipant } from '@repo/shared/src/services/identity-provider/identity-provider.types';

export interface participantsState {
  participants: IdentityProviderMessagingTokenParticipant[];
}
export const initialState: participantsState = {
  participants: [],
};
export const reducer = createReducer(
  initialState,
  on(fromActions.setParticipantList, (state, { participants }) => ({ ...state, participants })),
);
